/* eslint-disable react-hooks/exhaustive-deps */

import { Box, ThemeProvider, createTheme } from '@mui/material';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core';
import FullscreenSpinner from 'modules/common/fullscreenSpinner.component';
import React, { useEffect, useState } from 'react';
import { COLOR_PRIMARY, COLOR_SECONDARY, COLOR_WARNING } from 'styles/theme';
import { TOAST_MESSAGE_SEVERITY_ERROR } from 'modules/layout/types';
import { getSurveyQuestions, setSurveyLoadingComplete, getSurveyQuestionResponses, setQuestionId } from '../surveys.actions';
import { GET_SURVEY_QUESTIONS_FAILURE } from '../surveys.types';
import SurveyQuestionResponseDetails from './surveyQuestionResponseDetails.component';
import { getVendors } from 'modules/authorizations/store/actions/dataManagement.actions';
import { getAuthorizationSummaries } from 'modules/authorizations/store/actions/authorizations.actions';
import { GET_VENDORS_FAILURE } from 'modules/authorizations/store/types/dataManagementTypes';
import { GET_AUTHORIZATIONS_FAILURE } from 'modules/authorizations/store/types/authorizationTypes';
import { GET_CLIENTS_FAILURE } from 'modules/clients/types';
import { getClients } from 'modules/clients/clients.actions';
import { Permissions } from 'modules/layout/permissions';
import { hasPermission } from 'modules/layout/permissionService';

const styles = theme => ({
  card: {
    width: '100%',
    maxWidth: 1500,
    flexGrow: 1,
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  cardContainer: {
    maxWidth: '100% !important',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  cardDisplayContent: {
    maxWidth: '100% !important',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    margin: '10px'
  }
});

const SurveyQuestionResponseDetailsView = props => {
  const theme = createTheme({
    palette: {
      primary: COLOR_PRIMARY,
      secondary: COLOR_SECONDARY,
      warning: COLOR_WARNING
    }
  });

  const [responseDetails, setResponseDetails] = useState(props.surveyQuestionResponses ? props.surveyQuestionResponses.find(sq => sq.transfereeSurveyResponseId === parseInt(props.match.params.responseId)) : null);
  const [questionDetails, setQuestionDetails] = useState(props.surveyQuestions && responseDetails ? props.surveyQuestions.find(sq => sq.surveyQuestion.surveyQuestionId === parseInt(responseDetails.surveyQuestionId)) : null);
  const [authDetails, setAuthDetails] = useState(props.authorizationSummaries && responseDetails ? props.authorizationSummaries.find(auth => auth.fileId === responseDetails.authorizationFileId) : null);
  const [clientDetails, setClientDetails] = useState(props.clients && responseDetails ? props.clients[responseDetails.clientId] : null);
  const vendor = props.vendors && responseDetails ? props.vendors.find(v => v.vendorId === parseInt(responseDetails.linkedVendorId)) : null;

  const [isLoading, setIsLoading] = useState(false);

   useEffect(() => {
     async function fetchData () {
      setIsLoading(true);

         if (!props.vendors) {
          let vendorResp = await props.getVendors();
          if (vendorResp.type === GET_VENDORS_FAILURE) {
            props.showToast('Failed to retrieve vednors, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
          }
         }

         if (!props.surveyQuestions) {
          let surveyQuestionsResp = await props.getSurveyQuestions();
          if (surveyQuestionsResp.type === GET_SURVEY_QUESTIONS_FAILURE) {
              props.showToast('Failed to retrieve survey questions, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
          } else {
            const questionRespDetails = surveyQuestionsResp.response.questionResponsess ? surveyQuestionsResp.response.questionResponsess.find(sq => sq.transfereeSurveyResponseId === parseInt(props.match.params.responseId)) : null;
            setResponseDetails(questionRespDetails);
            setQuestionDetails(surveyQuestionsResp.response.surveyQuestions && questionRespDetails ? surveyQuestionsResp.response.surveyQuestions.find(sq => sq.surveyQuestion.surveyQuestionId === parseInt(questionRespDetails.surveyQuestionId)) : null);

            if (!props.authorizationSummaries) {
              let authSummariesResp = await props.getAuthorizationSummaries();
              if (authSummariesResp.type === GET_AUTHORIZATIONS_FAILURE) {
                props.showToast('Failed to retrieve authorizations, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
              } else {
                setAuthDetails(authSummariesResp.response && questionRespDetails ? authSummariesResp.response.find(auth => auth.fileId === questionRespDetails.authorizationFileId) : null)
              }
            } else {
              setAuthDetails(props.authorizationSummaries && questionRespDetails ? props.authorizationSummaries.find(auth => auth.fileId === questionRespDetails.authorizationFileId) : null);
            }

            if (!props.clients) {
              let clientsResp = await props.getClients();
              if (clientsResp.type === GET_CLIENTS_FAILURE) {
                props.showToast('Failed to retrieve clients, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
              } else {
                setClientDetails(clientsResp.response && questionRespDetails ? clientsResp.response.find(c => c.clientRecordId === questionRespDetails.clientId) : null);
              }
            } else {
              setClientDetails(props.clients && questionRespDetails ? props.clients[questionRespDetails.clientId] : null);
            }
          }
         } else {
          const questionRespDetails = props.surveyQuestionResponses ? props.surveyQuestionResponses.find(sq => sq.transfereeSurveyResponseId === parseInt(props.match.params.responseId)) : null;
          setResponseDetails(questionRespDetails);
          setQuestionDetails(questionRespDetails ? props.surveyQuestions.find(sq => sq.surveyQuestion.surveyQuestionId === parseInt(questionRespDetails.surveyQuestionId)) : null);
         }

       setIsLoading(false);
     }

     fetchData();

   }, []);

  if (!hasPermission(Permissions.Admin.Surveys.Read)) {
    props.history.push('/');
    return null;
  }

  return (
    <ThemeProvider theme={theme}>
      <Box>
        {!isLoading && questionDetails && responseDetails && <Box sx={{ padding: '30px' }}><SurveyQuestionResponseDetails surveyQuestion={questionDetails} responseDetails={responseDetails} authorization={authDetails} vendor={vendor} variation={{}} clientDetails={clientDetails} /></Box>}
        {(isLoading || !questionDetails) && <FullscreenSpinner />}
      </Box>
    </ThemeProvider>
  );
};

const mapStateToProps = (state) => {
    const {
        authorizations: { authorizationSummaries, vendors },
        surveys: { surveyQuestions, surveyQuestionResponses, isLoading },
        clients: { clients },
    } = state;
    return { authorizationSummaries, vendors, surveyQuestions, surveyQuestionResponses, isLoading, clients };
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps, {
    getSurveyQuestions,
    setSurveyLoadingComplete,
    getSurveyQuestionResponses,
    getVendors,
    getAuthorizationSummaries,
    setQuestionId,
    getClients
  })
)(SurveyQuestionResponseDetailsView);
